import React from 'react';
import map from 'lodash/map';

import { UPLOAD_STATUS } from './constants';
import { formatDateTime } from 'helpers/dateTimeFormatter';
import { getBulkUploadDeviceTypeLabel } from '../helpers';


const statusColumnFormatter = (cell, translate) => {
    const status = translate(`ABB.Powertrain.Frontend.ptHierarchyBulkUploadStatusCode_${cell.status}`);
    let statusDetails = null;
    if (cell.status === UPLOAD_STATUS.Analyzing || cell.status === UPLOAD_STATUS.AnalyzingStep1 || cell.status === UPLOAD_STATUS.AnalyzingStep2 || cell.status === UPLOAD_STATUS.AnalyzingStep3) {
        statusDetails = <>({cell?.analyticsProgressInPercent}%)</>;
    }
    else if (cell.status === UPLOAD_STATUS.Done) {
        const failedFiles = <span style={cell.failedFiles ? { color: 'red' } : {}}>{cell.failedFiles}</span>;
        statusDetails = <>
            ({cell.processedFiles} {translate('ABB.Powertrain.Frontend.detailedInformationBulkUploadStatusOK')}, {failedFiles} {translate('ABB.Powertrain.Frontend.detailedInformationBulkUploadStatusFailed')})
        </>;
    }
    const cellValue = <>
        {status} {statusDetails}
    </>;
    return cellValue;
};

export const getColumns = (translate, selectedAsset) => {
    return [
        {
            title: translate('ABB.Powertrain.Frontend.detailedInformationBulkUploadColumnSLNO', { deviceType: getBulkUploadDeviceTypeLabel(selectedAsset) }),
            dataIndex: 'gatewaySerialnumber',
            key: 'gatewaySerialnumber',
            isSorting: true,
            width: 150,
            fixed: 'left'
        },
        {
            title: translate('ABB.Powertrain.Frontend.detailedInformationBulkUploadColumnDrive'),
            dataIndex: 'driveSerialnumber',
            key: 'driveSerialnumber',
            isSorting: true,
            width: 150,
        },
        {
            title: translate('ABB.Powertrain.Frontend.detailedInformationBulkUploadColumnFileName'),
            dataIndex: 'filename',
            key: 'filename',
            width: 150,
            isSorting: true
        },
        {
            title: translate('ABB.Powertrain.Frontend.detailedInformationBulkUploadColumnUploadedBy'),
            dataIndex: 'initiatedby',
            key: 'initiatedby',
            width: 150,
            isSorting: true
        },
        {
            title: translate('ABB.Powertrain.Frontend.detailedInformationBulkUploadColumnUploadedTime'),
            dataIndex: 'uploadTimeUtc',
            key: 'uploadTimeUtc',
            width: 150,
            isSorting: true,
            render: (date) => formatDateTime(date)
        },
        {
            title: translate('ABB.Powertrain.Frontend.detailedInformationBulkUploadColumnStatus'),
            dataIndex: 'status',
            key: 'status',
            width: 100,
            isSorting: true,
            render: (status) => statusColumnFormatter(status, translate)
        }

    ];
};
export const getPredefinedRangeStart = (daysBack) => {
    const today = new Date();

    const startDate = new Date(today);
    startDate.setDate(startDate.getDate() - daysBack);
    startDate.setHours(0, 0, 0, 0);

    return startDate;
};

export const formatDateForApi = (date) => {
    if (!date) { return ''; }
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
};
export const formatUploadList = (uploadList) => {
    const formattedList = map(uploadList, (uploadListItem, index) => {
        const uniqueId = [uploadListItem.filename, uploadListItem.gatewaySerialnumber, uploadListItem.driveSerialnumber, index].filter(Boolean).join('_');
        return {
            ...uploadListItem,
            id: uniqueId,
            originalIndex: index,
            status: {
                ...uploadListItem.status,
                sortingItem: uploadListItem.status.status
            }
        };
    });

    // Sort by uploadTimeUtc descending (newest first), then by ID descending for same timestamps
    return formattedList.sort((a, b) => {
        const dateA = new Date(a.uploadTimeUtc);
        const dateB = new Date(b.uploadTimeUtc);
        const dateDiff = dateB - dateA;

        // If dates are equal, sort by originalIndex descending (higher index = more recent)
        if (dateDiff === 0) {
            return b.originalIndex - a.originalIndex;
        }

        return dateDiff;
    });
};
